import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.scss';
import tribePNG from 'resources/common/tribe-acad-student.png';

function Logo(props) {
  const { isIcon, className: classNameProp } = props;

  const logoClassName = classNames('logo', { 'logo-icon': isIcon }, classNameProp);

  const logo = <img src={tribePNG} className={logoClassName} alt="logo-icon" />;

  return <div className="logo-container">{logo}</div>;
}

Logo.propTypes = {
  // isIcon: PropTypes.bool,
  className: PropTypes.string,
  titleAccess: PropTypes.string,
  viewBox: PropTypes.string,
};

Logo.defaultProps = {
  color: 'inherit',
  viewBox: '0 0 24 24',
};

export default Logo;



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/Logo/Logo.js